module.exports = __webpack_public_path__ + "static/media/sphere.13dd02cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/sphere.svg
// module id = 3536
// module chunks = 7